import { useClassified } from "@/contexts/classified";
// eslint-disable-next-line no-restricted-imports
import { useThorEvent } from "@aviv-dxp/react-thor";
export const useTrackingLegacyInterest = ({ type, infos, }) => {
    var _a, _b;
    const products = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.legacyTracking) === null || _b === void 0 ? void 0 : _b.products;
    const eventData = {
        type,
        description: "interest",
        infos,
        products,
        event: "interaction",
    };
    return useThorEvent({
        compatibilities: { GA3: true, GA4: false },
        eventData,
    });
};
